import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import {
  FAQApp,
  ParametricSearchApp,
  FAQTopApp,
  FullTextSearchApp,
  OctopartApp,
  KeywordSearchApp,
  KeywordSearchTopApp
} from "./App";
import config from "./config";
import i18n from "./i18n";

const FAQWrapper = (
  <I18nextProvider i18n={i18n}>
    <FAQApp />
  </I18nextProvider>
);
const KeywordWrapper = (
  <I18nextProvider i18n={i18n}>
    <KeywordSearchApp />
  </I18nextProvider>
);

const KeywordTopWrapper = (
  <I18nextProvider i18n={i18n}>
    <KeywordSearchTopApp />
  </I18nextProvider>
);

const FAQTopWrapper = (
  <I18nextProvider i18n={i18n}>
    <FAQTopApp />
  </I18nextProvider>
);
const ParametricSearchWrapper = (
  <I18nextProvider i18n={i18n}>
    <ParametricSearchApp />
  </I18nextProvider>
);
const FullTextSearchWrapper = (
  <I18nextProvider i18n={i18n}>
    <FullTextSearchApp />
  </I18nextProvider>
);

const OctopartWrapper = (
  <I18nextProvider i18n={i18n}>
    <OctopartApp />
  </I18nextProvider>
);

if (config.isLocalDevelopment) {
  if (config.currentDevelopmentApplication === "faq-app") {
    const faqApp = document.getElementById("faq-app");
    ReactDOM.render(FAQWrapper, faqApp);
  }

  if (config.currentDevelopmentApplication === "keyword-app") {
    const faqApp = document.getElementById("keyword-app");
    ReactDOM.render(KeywordWrapper, faqApp);
  }

  if (config.currentDevelopmentApplication === "keyword-app-top") {
    const faqApp = document.getElementById("keyword-app-top");
    ReactDOM.render(KeywordTopWrapper, faqApp);
  }

  if (config.currentDevelopmentApplication === "faq-top-app") {
    const faqApp = document.getElementById("faq-top-app");
    ReactDOM.render(FAQTopWrapper, faqApp);
  }

  if (config.currentDevelopmentApplication === "parametric-search-app") {
    const faqApp = document.getElementById("parametric-search-app");
    ReactDOM.render(ParametricSearchWrapper, faqApp);
  }

  if (config.currentDevelopmentApplication === "full-text-search-app") {
    const faqApp = document.getElementById("full-text-search-app");
    ReactDOM.render(FullTextSearchWrapper, faqApp);
  }

  if (config.currentDevelopmentApplication === "octopart-app") {
    const faqApp = document.getElementById("octopart-app");
    ReactDOM.render(OctopartWrapper, faqApp);
  }
} else {
  const faqApp = document.getElementById("faq-app");
  const keywordApp = document.getElementById("keyword-app");
  const keywordTopApp = document.getElementById("keyword-app-top");
  const faqTopApp = document.getElementById("faq-top-app");
  const parametricSearchApp = document.getElementById("parametric-search-app");
  const fullTextSearchApp = document.getElementById("full-text-search-app");
  const octopartApp = document.getElementsByClassName("octopart-app");

  if (faqApp) {
    ReactDOM.render(FAQWrapper, faqApp);
  }

  if (keywordApp) {
    ReactDOM.render(KeywordWrapper, keywordApp);
  }

  if (keywordTopApp) {
    ReactDOM.render(KeywordTopWrapper, keywordTopApp);
  }

  if (parametricSearchApp) {
    ReactDOM.render(ParametricSearchWrapper, parametricSearchApp);
  }

  if (faqTopApp) {
    ReactDOM.render(FAQTopWrapper, faqTopApp);
  }

  if (fullTextSearchApp) {
    ReactDOM.render(FullTextSearchWrapper, fullTextSearchApp);
  }
  if (octopartApp) {
    window.octopartAppRender = model => ReactDOM.render(OctopartWrapper, model);
  }
}
